<template>
  <div id="scroll" class="top bg-white" v-if="favoriteList && recommended && recentRentalProperties && browser && articlesList && reportStatus">
    <navbar />
    <section class="mv_box" :style="mvBox">
      <div class="mv_inner wrapper">
        <h1 v-html="$t('catchphrase')"></h1>
      </div>
    </section>

    <section class="top_client top_section">
      <div class="wrapper property-list">
        <div class="top_section_title">
          <h2>{{ $t('おすすめ売買物件') }}</h2>
          <a @click="propertyList" class="pc top_list_btn">{{ $t('売買物件一覧')}}</a>
        </div>
        <div class="property_contents_list">
          <ul>
            <li v-for="(item, index) in recommended" :key="index">
              <property-item :item="item" />
            </li>
          </ul>
        </div>
        <a @click="propertyList" class="sp top_list_btn">{{ $t('売買物件一覧') }}</a>
      </div>
      <div class="wrapper" v-if="reportStatus.length !== 0">
        <div class="top_section_title">
          <h3>{{ $t('販売実績') }}</h3>
          <a @click="soldPropertyList" class="pc top_list_btn">{{$t('販売実績一覧')}}</a>
        </div>
        <div class="top_house_list">
          <ul>
            <li v-for="(item, index) in reportStatus" :key="index">
              <property-item :item="item" :link="true" />
            </li>
          </ul>
        </div>
        <a @click="soldPropertyList" class="sp top_list_btn">{{$t('販売実績一覧')}}</a>
        <router-link :to="{ name: 'Client Property Map', params: {lang: activeLanguage}}" class="top_prefecture_btn">
          <span>{{$t('都道府県から探す')}}</span>
        </router-link>
      </div>
    </section>

    <section class="top_rental top_section">
      <div class="wrapper property-list">
        <div class="top_section_title">
          <h2>{{ $t('新着賃貸物件') }}</h2>
          <div class="pc top_list_btn_wrapper">
            <a :href="`/${activeLanguage}/rental/residential-property-list/`" class="top_list_btn">{{ $t('residential_rental_property') }}</a>
            <a :href="`/${activeLanguage}/rental/commercial-property-list/`" class="top_list_btn">{{ $t('commercial_rental_property') }}</a>
          </div>
        </div>
        <div class="property_contents_list">
          <ul>
            <li v-for="(property) in recentRentalProperties" :key="property.id">
              <property-item :item="property" />
            </li>
          </ul>
        </div>
        <a :href="`/${activeLanguage}/rental/residential-property-list/`" class="sp top_list_btn">{{ $t('residential_rental_property') }}</a>
        <a :href="`/${activeLanguage}/rental/commercial-property-list/`" class="sp top_list_btn">{{ $t('commercial_rental_property') }}</a>
      </div>
    </section>

    <section class="top_favorite_history top_section">
      <div class="wrapper">
        <div class="top_section_title" v-if="favoriteList.length !== 0">
          <h3>{{ $t('お気に入り') }}</h3>
        </div>
        <div class="top_house_list top_house_list_favorit" v-if="favoriteList.length !== 0">
          <fade-transition mode="out-in">
          <ul key="item">
            <li v-for="(item, index) in favoriteList" :key="index" v-bind:class="{ 'openDisplay': readOpen }">
              <property-item :item="item" :link="true" />
            </li>
          </ul>
          </fade-transition>
          <button v-show="hide" type="button" class="readMoreBtn" v-on:click="readOpen = !readOpen" v-bind:class="{ 'open': readOpen }">{{$t('すべて表示')}}</button>
        </div>
        <div class="top_section_title" v-if="browser.length !== 0">
          <h3>{{$t('閲覧履歴')}}</h3>
        </div>
      </div>
      <div class="top_house_list top_house_list_log" v-if="browser.length !== 0">
        <ul>
          <VueSlickCarousel ref="carousel" v-bind="settings" :arrows="arrows">
            <li v-for="(item, index) in browser" :key="index">
              <property-item :item="item" :link="true" />
            </li>
          </VueSlickCarousel>
        </ul>
      </div>
    </section>
    <section class="top_blog top_section" :style="topBlog">
      <div class="wrapper">
        <div class="top_section_title">
          <h2>{{$t('会員限定ブログ')}}</h2>
          <a @click="articlesLists" v-smooth-scroll class="pc top_list_btn">{{$t('記事一覧')}}</a>
        </div>
        <div class="top_blog_inner">
          <ul>
            <li v-for="(item, index) in articlesList" :key="index">
              <a @click="blogDetails(item.blog_articles_details[0].blog_article_id)">
                <div class="thumb-box">
                  <img :src="item.blog_images.url">
                </div>
                <div class="top_blog_txt">
                  <h3>{{item.blog_articles_details[0].title}}</h3>
                  <p>{{moment(item.created_at).format('YYYY/MM/DD')}}</p>
                </div>
                <span class="top_blog_cat">{{$t(item.category)}}</span>
              </a>
            </li>
          </ul>
        </div>
        <a @click="articlesLists" href="#scroll" v-smooth-scroll class="sp top_list_btn">{{$t('記事一覧')}}</a>
      </div>
    </section>

    <section class="top_contact top_section">
      <div class="wrapper">
        <div class="top_contact_wrapper" :style="topContact">
          <div class="top_contact_title">
            <h3>{{ $t('contact') }}</h3>
          </div>
          <div class="top_contact_link">
            <router-link :to="{ name: 'Client Contact', params: { lang: $route.params.lang } }" class="top_list_btn">{{ $t('enquiry_page') }}</router-link>
          </div>
        </div>
      </div>
    </section>

    <footerClient />
  </div>
</template>

<script>
import navbar from '@/components/client/navbar'
import footerClient from '@/components/client/footerClient'
import FadeTransition from '@/views/client/FadeTransition.vue'
import { mapActions, mapState } from 'vuex'
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import PropertyItem from './components/property-item'

export default {
  data () {
    return {
      activeLanguage: this.$route.params.lang,
      readOpen: false,
      settings: {
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1100,
            settings: {
              slidesToShow: 3
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2
            }
          }
        ]
      },
      mvBox: {
        background: `url(${require('@/assets/img/client/top_bg.png')}) center / cover`
      },
      topBlog: {
        background: `url(${require('@/assets/img/client/top_blog_bg.png')}) center / cover`
      },
      topContact: {
        background: `url(${require('@/assets/img/client/top_contact_bg.png')}) center center/cover`
      }
    }
  },
  components: {
    navbar,
    footerClient,
    FadeTransition,
    VueSlickCarousel,
    PropertyItem
  },
  created () {
    this.favoriteListFunction()
    this.getArticles()
    this.browseHistoryList()
    this.recommendedProperty()
    this.getRecentRentalProperties()
    this.reportStatusData()
  },
  computed: {
    ...mapState('propertyClient', ['favoriteList', 'browser', 'recommended', 'recentRentalProperties', 'reportStatus']),
    ...mapState('blogClient', ['articlesList']),
    hide: function () {
      if (this.favoriteList) {
        if (this.favoriteList.length > 3) {
          return true
        }
      }
      return false
    },
    arrows: function () {
      if (this.browser.length >= 4) {
        return true
      }
      return false
    }
  },
  methods: {
    ...mapActions('propertyClient', ['favoriteListFunction', 'browseHistoryList', 'recommendedProperty', 'getRecentRentalProperties', 'reportStatusData']),
    ...mapActions('blogClient', ['getArticles']),
    propertyDetailsDisplay: function (data) {
      this.$router.push({ name: 'Client Property Detail', params: { id: data } })
    },
    blogDetails: function (id) {
      this.$router.push({ name: 'Client Blog Detail', params: { id: id } })
    },
    articlesLists: function () {
      this.$router.push({ name: 'Client Blog List', params: { lang: this.$route.params.lang } })
    },
    propertyList () {
      this.$router.push({ name: 'Client Property List', params: { lang: this.$route.params.lang } })
    },
    soldPropertyList () {
      this.$router.push({ name: 'Client Sold Property List', params: { lang: this.$route.params.lang, sold: '販売済' } })
    },
    tallClass: function (image) {
      let img = null
      img = new Image()
      img.src = image
      if (img.height < img.width) {
        return 'thumb-box'
      } else {
        return 'thumb-box tall'
      }
    }
  },
  mounted: function () {
    const styleId = 'top_icons'
    if (document.getElementById(styleId)) return

    const iconStyle = `
.top_client h2::before {
  background-image: url(${require('@/assets/img/client/icon-client.png')});
}
.top_rental h2::before {
  background-image: url(${require('@/assets/img/client/icon-rental.png')});
}
.top_blog h2::before {
  background-image: url(${require('@/assets/img/client/icon-blog.png')});
}
.top_contact .top_list_btn::before {
  background: url(${require('@/assets/img/client/icon-contact.png')}) top center / cover;
}
.top_prefecture_btn span::before {
  background: url(${require('@/assets/img/client/top_prefecture_btn_ico.png')}) 0 0 no-repeat;
  background-size: cover;
}
`
    const style = document.createElement('style')
    document.head.appendChild(style)
    style.setAttribute('id', styleId)
    style.innerHTML = iconStyle
  }
}
</script>
